import {
  ResponsiveContextProvider,
  ResponsiveDetailCol,
  ResponsiveListCol
} from '@monorepo/common/component/responsive/ResponsiveContextProvider';
import React from 'react';
import { Route, useRouteMatch } from 'react-router-dom';
import { Container, Row } from 'reactstrap';
import TokenDetail from '../component/token/TokenDetail';
import TokenFilterableList from '../component/token/TokenFilterableList';

export default function TokensPage() {
  const { path: parentPath, url: parentUrl } = useRouteMatch();
  const path = `${parentPath}/:tokenId?`;
  const match = useRouteMatch<{ tokenId?: string }>(path);
  const tokenId = match?.params.tokenId;

  return (
    <ResponsiveContextProvider single={false} selectedId={tokenId}>
      <Route path={path}>
        <Container>
          <Row>
            <ResponsiveListCol>
              <div className="position-fixed-scrollable">
                <TokenFilterableList tokenId={tokenId} url={parentUrl} />
              </div>
            </ResponsiveListCol>

            <ResponsiveDetailCol>
              <TokenDetail tokenId={tokenId} listUrl={parentUrl} />
            </ResponsiveDetailCol>
          </Row>
        </Container>
      </Route>
    </ResponsiveContextProvider>
  );
}
